import React, { type Attributes } from 'react'
import { Grid, Skeleton } from '@fs/zion-ui'
import ConclusionContainer from '../../components/ConclusionContainer'

type Props = {
  columns: Attributes['columns']
}

export default function OtherRelationshipsLoading({ columns }: Props): JSX.Element {
  return (
    <Grid guttersY="nano">
      <ConclusionContainer columns={columns}>
        <Skeleton.Paragraph />
        <Skeleton.PersonBlock />
      </ConclusionContainer>
      <ConclusionContainer columns={columns}>
        <Skeleton.Paragraph />
        <Skeleton.PersonBlock />
      </ConclusionContainer>
    </Grid>
  )
}
